/* eslint-disable xss/no-mixed-html */
/* eslint-disable vars-on-top */
/* eslint-disable no-useless-concat*/
/* eslint-disable max-statements*/
ACC.recommendedadditionalproducts = {
  rvbindAll: function(prodCode) {
    ACC.recommendedadditionalproducts.rvgetProdData(prodCode);


    ACC.recommendedadditionalproducts.rvactivePage();
  },

  displayCorousel: function() {
    if ($('.ph-recentlyviewed-products li').length > 0) {
      if ($(window).width() > 600) {
        ACC.recommendedadditionalproducts.rvcardsCarousel();
      } else {
        var rvcardWidth = $('.ph-recentlyviewed-products__jcarousel').innerWidth() / 2;

        $('.ph-recentlyviewed-products').find('li').css('width', rvcardWidth + 'px');
      }
    }
  },

  rvgetProdData: function(prodCode) {
    var indx = 0,
        codes = [],
        rvids = '',
        promRibbon = $('.ph-promotionribbon').val(),
        newIndicator = $('.ph-newindicator').val(),
        preferredtext = $('#ph-preferredtext').val(),
        preferredid = $('#ph-preferredid').val(),
        unitpriceaddVal = $('#ph-unitpriceadd').val(),
        dhcainJsIndicator = '';


    $('.ph-spinnersuggested').removeClass('hidden');
    $.ajax({
      type: 'POST',
      url: ACC.config.encodedContextPath + '/asyncproduct/getRecommendedProducts',
      dataType: 'json',
      data: {
        codes: prodCode
      },
      /* eslint-disable complexity*/
      success: function(result) {
        if (result.length > 0) {
          $('.ph-recommended-products').removeClass('hidden');
          $('.ph-homepage-suggested').removeClass('hidden');
        }

        if (Array.isArray(result) && result.length > 0) {
          for (indx; indx < result.length; indx = indx + 1) {
            var prodUnits = '',
                unitsText = '',
                updateProdCtv = '',
                updateProdDisplayName = '',
                currentIndex = indx + 1,
                gaListName = $('.ph-ga_rec_listname').val(),
                gaCtv = result[indx].product.ctv,
                gaProdCode = result[indx].product.code,
                preferredCode = gaProdCode,
                updatedCtv = '',
                emptytxt = $('.ph-notAvailTxt').val(),
                arrayofdchain = 0;

            arrayofdchain = ACC.decisionPageInfiniteLoader.checkdchainInList();

            if (preferredid === 'PRODUCT_EAN') {
              preferredCode = result[indx].product.sapEan;
            }

            if (preferredCode.length === 0) {
              preferredCode = emptytxt;
            }

            updateProdCtv = ACC.interstitialPopUp.recomIntertitialUpdateProdCtv(result[indx].product.ctv, 'ctv');
            updateProdDisplayName = ACC.interstitialPopUp.recomIntertitialUpdateProdCtv(result[indx].product.displayName, 'displayName');

            if (result[indx].product.numberContentUnits) {
              prodUnits = result[indx].product.numberContentUnits;
              unitsText = $('.ph-produnits').val();
            }

            if ($('.ph-dchain_Indicator').length > 0) {
              dhcainJsIndicator = $('.ph-dchain_Indicator').val();
            }

            if (gaCtv) {
              updatedCtv = gaCtv.replace('/', '-');
            } else {
              updatedCtv = gaProdCode;
            }

            $('.ph-spinnersuggested').addClass('hidden');
            $('.ph-ra_additional-products').append('<li  class="ph-ra_productcard ph-recom_' + result[indx].product.code +
            '" id="prodcode-' +
            updatedCtv + '" data-prodid = "' + result[indx].product.code +
                    '" data-ctn = "' + result[indx].product.ctv + '" data-list-name = "' + gaListName +
                    '" data-list-position = "' + currentIndex + '" data-track-productcard-visibility>' +
                    '<div class="ph-card-item" id= ' + rvids + '>' +
                    '<a  class="ph-product-url" href = ' + ACC.config.encodedContextPath + result[indx].product.url + '>' +
                    '<div class="ph-pro-outer-wrap">' +
                    '<div class="ph-topwrap">' +
                    '<div class="ph-card-image-wrapper">' +
                    '<img class="ph-product-image ph-card-image" src="' + result[indx].product.imageURL + '&wid=145&hei=145&$jpglarge$">' +

                    '<div class="p-promotion-ribbon p-promotion-ribbon--new ph-new-indicator">' +
                    '<div class="p-promotion-ribbon-inner">' + newIndicator +

                    '</div></div>' +
                    dhcainJsIndicator +
                    '<div class="ph-discount-ribbon hidden-xs ph-product-card__ribbon">' +
                    '<div class="ph-discount-ribbon__text ph-body-copy-03 ph-bold ph-bg__solid-wordmark-blue">' +
                    '<span>' + promRibbon + '</span>' +
                    '</div></div></div>' +

                    '<div class="ph-card-product-details">' +
                    '<p class="ph-product-number">' +
                    '<span class="ph-product-sku">' + '<span class="ph-prvalue ph-recommprod">' + preferredtext + '</span>: ' + preferredCode +
                            '</span>' + updateProdCtv +

                    '</p>' + updateProdDisplayName +

                    '</div></div>' +
                    '</div></a>' + '<div class="ph-sg-price-wrapr">' + unitpriceaddVal +
                    '<p class="ph-product-price" id= ' + result[indx].product.code + '>' +
                    '<span class="ph-ra_list-price">' +
                    '</span>' +
                    '<span class="ph-strike-price">' +
                    '</span>' +
                    '</p></div>' +
                    '<div class="ph-product-count">' +
                      '<span class="ph-pkgqty">' + prodUnits + ' ' + '</span>' +
                       '<span class="ph-pkgunit">' + unitsText + '</span></div>' +
                    '</div></li>');


            codes.push(result[indx].product.code);

            if ($.inArray(result[indx].product.dchainValue, arrayofdchain) !== -1) {
              $('#prodcode-' + updatedCtv).find('.ph-dchainvalue' + result[indx].product.dchainValue).removeClass('ph-d-none');
            }
          }

          ACC.recommendedadditionalproducts.displayCorousel();
          ACC.recommendedadditionalproducts.rvgetPrice(codes);
        }
      }
      /* eslint-enable complexity*/
    });
  },

  rvgetPrice: function(prodcodesrec) {
    $.ajax({
      type: 'POST',
      url: ACC.config.encodedContextPath + '/asyncproduct/getpricedata',
      dataType: 'json',
      data: {
        codes: prodcodesrec.toString()
      },
      success: function(resultList) {
        var indx = 0;

        if (Array.isArray(resultList) && resultList.length > 0) {
          for (indx; indx < resultList.length; indx = indx + 1) {
            ACC.recommendedadditionalproducts.rvbindPrice(resultList[indx]);
          }
        }
      }

    });
  },

  checknull: function(recently) {
    if (recently) {
      return recently;
    }

    return '';
  },

  rvbindPrice: function(rvitem) {
    var $isPromotionEnabled = $('.ph-promotionenabled');

    var prodPriceList = rvitem.priceList;
    var rowPrice = '';
    var priceIndx = '';

    if (prodPriceList.length > 0) {
      for (priceIndx = 0; priceIndx < prodPriceList.length; priceIndx = priceIndx + 1) {
        rowPrice = prodPriceList[priceIndx];
        ACC.interstitialPopUp.recomIntertitialPriceContent(rowPrice, $isPromotionEnabled.length, rvitem.code, rvitem.discountPromotion);
      }
    }
  },

  rvresizeAll: function() {
    var rvimageHeight = 0,
        rvcontentHeight = 0,
        $listItems = $('.ph-recentlyviewed-products').find('li');

    $listItems.each(function() {
      var rvcheight = $(this).find('.ph-card-image-wrapper').outerHeight();
      var rvoheight = $(this).find('.ph-card-product-details').outerHeight();

      if (rvimageHeight < rvcheight) {
        rvimageHeight = rvcheight;
      }

      if (rvcontentHeight < rvoheight) {
        rvcontentHeight = rvoheight;
      }
    });

    $listItems.find('.ph-card-image-wrapper').height(rvimageHeight);
    $listItems.find('.ph-card-product-details').height(rvcontentHeight);
  },
  rvcardsCarousel: function() {
    var rvinactive = 'ph-inactive',
        $jcarousel = '',
        intertitialpop = '';

    if ($('#cboxLoadedContent .ph-recentlyviewed-products__jcarousel').length > 0) {
      intertitialpop = '#cboxLoadedContent ';
      $jcarousel = $(intertitialpop + '.ph-recentlyviewed-products__jcarousel');
    } else {
      $jcarousel = $('.ph-recentlyviewed-products__jcarousel');
    }

    $jcarousel.on('jcarousel:reload jcarousel:create', function() {
      var $carousel = $(this),
          rvwidth = $carousel.innerWidth();

      if (rvwidth >= 768) {
        rvwidth = rvwidth / 4;
        ACC.common.setCarouselWidth($jcarousel, rvwidth, 4);
      } else if (rvwidth <= 768 && rvwidth >= 414) {
        rvwidth = rvwidth / 3;
      } else if (rvwidth <= 414) {
        rvwidth = rvwidth / 2;
      }

      $carousel.jcarousel('items').css('width', Math.ceil(rvwidth) + 'px');
    }).jcarousel({
      wrap: null
    });

    $(intertitialpop + '.ph-recentlyviewed-products__prevarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass(rvinactive);
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass(rvinactive);
    }).jcarouselControl({
      target: '-=1'
    });

    $(intertitialpop + '.ph-recentlyviewed-products__nextarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass(rvinactive);
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass(rvinactive);
    }).jcarouselControl({
      target: '+=1'
    });

    $('.ph-jcarousel-rv-pagination').jcarouselPagination({
      perPage: 3,
      item: function(page) {
        return '<a href="#' + page + '"><span class="ph-jcarousel-pagination-dot" data-page="' + page + '"></span></a>';
      }
    });

    $jcarousel.on('jcarousel:animateend', function() {
      ACC.recommendedadditionalproducts.rvactivePage();
    });
  },
  rvactivePage: function() {
    var rvpageNumber = 1;
    var rvnavigationList = $('.ph-jcarousel-rv-pagination').find('a');
    var rvcompleteUrl = window.location.href;

    if (rvcompleteUrl.indexOf('#') !== -1) {
      rvpageNumber = rvcompleteUrl.split('#').splice(1, 1).join();
    }

    rvnavigationList.each(function() {
      $(this).find('span').removeClass('ph-active-page');

      if (('#' + rvpageNumber) === $(this).attr('href')) {
        $(this).find('span').addClass('ph-active-page');
      }
    });
  }
};
$(document).ready(function() {
  var prodCode = '';

  if ($('.page-productDetails').length > 0) {
    prodCode = $('#ph-prod-code').val();
  } else {
    prodCode = ' ';
  }

  if (($('.page-productDetails').length > 0 && $('.ph-ra_flag_enabled').length > 0) ||
      ($('.pageLabel-newHomePage').length > 0 && $('.ph-ra_flag_enabled').length > 0)) {
    ACC.recommendedadditionalproducts.rvbindAll(prodCode);
  }
});

/* eslint-enable xss/no-mixed-html */
/* eslint-enable vars-on-top */
/* eslint-enable no-useless-concat*/
/* eslint-enable max-statements*/

